/* Cane Creek cart drawer v2 (Oct 2026). Runs only when window.ccCartV2 is true (see snippets/cc-cart-v2.liquid). */
(function () {
  if (!window.ccCartV2) return;

  var IS_US = window.ccCountry === 'US';
  var SHORT_SCREEN = 760;
  var RECS_MIN_SPACE = 120; // px a compact rec card needs (card + padding)
  var lastReached = null;
  var recsOpen = null;
  var scheduled = false;

  try {
    var saved = sessionStorage.getItem('cc_recs_open');
    if (saved === '1') recsOpen = true;
    if (saved === '0') recsOpen = false;
  } catch (e) {}

  var fmt;
  try {
    fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.ccCurrency || 'USD' });
  } catch (e) {
    fmt = { format: function (n) { return '$' + n.toFixed(2); } };
  }
  function money(cents) { return fmt.format(Math.max(0, cents) / 100); }

  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M2 6h11v9H2zM13 9h4l4 4v2h-8z" stroke-width="1.8" stroke-linejoin="round"/><circle cx="6" cy="17.5" r="1.8" stroke-width="1.8"/><circle cx="17" cy="17.5" r="1.8" stroke-width="1.8"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV = '<svg class="cc-recs-head__chev" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1.5 3.5L5 7l3.5-3.5" stroke="currentColor" stroke-width="1.5"/></svg>';

  function remainingCents(drawer) {
    var bar = drawer.querySelector('free-shipping-bar');
    if (!bar || !IS_US) return null;
    var threshold = parseFloat(bar.getAttribute('threshold'));
    var total = parseFloat(bar.getAttribute('total-price'));
    if (isNaN(threshold) || isNaN(total)) return null;
    return Math.max(0, Math.round(threshold - total));
  }

  function setHTML(el, html) { if (el.innerHTML !== html) el.innerHTML = html; }

  function updateShippingBar(drawer) {
    var bar = drawer.querySelector('free-shipping-bar');
    if (!bar) return null;
    var remaining = remainingCents(drawer);
    if (remaining === null) return null;

    // Appended (not prepended) so the theme's own message writer, which targets the first <span>, keeps writing to its hidden element.
    var msg = bar.querySelector(':scope > .cc-fsb-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'cc-fsb-msg';
      msg.setAttribute('role', 'status');
      msg.style.order = '-1';
      bar.appendChild(msg);
    }

    var reached = remaining <= 0;
    var html = reached
      ? '<div class="cc-fsb-icon">' + CHECK + '</div><div>You’ve unlocked <strong>free shipping</strong></div>'
      : '<div class="cc-fsb-icon">' + TRUCK + '</div><div>You’re <strong class="cc-fsb-amt">' + money(remaining) + '</strong> away from <strong>free shipping</strong></div>';
    setHTML(msg, html);
    bar.classList.toggle('cc-fsb--reached', reached);

    if (reached && lastReached === false) {
      bar.classList.remove('cc-fsb--celebrate');
      void bar.offsetWidth;
      bar.classList.add('cc-fsb--celebrate');
    }
    lastReached = reached;
    return remaining;
  }

  function priceCents(block) {
    var nodes = block.querySelectorAll('.rebuy-product-price .rebuy-money:not(.compare-at)');
    if (!nodes.length) return null;
    var txt = nodes[nodes.length - 1].textContent || '';
    var n = parseFloat(txt.replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : Math.round(n * 100);
  }

  function updateRecs(drawer, remaining) {
    var hasItems = !!drawer.querySelector('.line-item');
    var inner = drawer.querySelector(':scope > .cart-drawer__inner');
    var head = drawer.querySelector(':scope > .cc-recs-head');
    var blocks = drawer.querySelectorAll('.cart-drawer__upsell .rebuy-product-block');

    if (!hasItems || !inner || !blocks.length) {
      if (head) head.style.display = 'none';
      return;
    }

    if (!head) {
      head = document.createElement('button');
      head.type = 'button';
      head.className = 'cc-recs-head';
      head.innerHTML = '<span class="cc-recs-head__row">' + CHEV + '<span class="cc-recs-head__title"></span></span><span class="cc-recs-head__hint"></span>';
      head.addEventListener('click', function () {
        recsOpen = head.getAttribute('aria-expanded') !== 'true';
        try { sessionStorage.setItem('cc_recs_open', recsOpen ? '1' : '0'); } catch (e) {}
        head.setAttribute('aria-expanded', String(recsOpen));
        // Let Flickity re-measure once the carousel is visible again
        setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 60);
      });
    }
    if (head.previousElementSibling !== inner) inner.after(head);
    head.style.display = '';

    var open = recsOpen;
    if (open === null) {
      // Adaptive: show recs only if they fit under the cart items without pushing them out of view
      var topEl = drawer.querySelector('.cart-drawer__top');
      var footer = drawer.querySelector('[slot="footer"]');
      var items = drawer.querySelector('.drawer__products_mian');
      if (topEl && footer && items && footer.offsetHeight > 0) {
        var avail = footer.getBoundingClientRect().top - topEl.getBoundingClientRect().bottom;
        open = (avail - items.offsetHeight - head.offsetHeight) >= RECS_MIN_SPACE;
      } else {
        open = window.innerHeight > SHORT_SCREEN;
      }
    }
    if (head.getAttribute('aria-expanded') !== String(open)) {
      head.setAttribute('aria-expanded', String(open));
      if (open) setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 60);
    }

    var title = 'You may also like (' + blocks.length + ')';
    var titleEl = head.querySelector('.cc-recs-head__title');
    if (titleEl.textContent !== title) titleEl.textContent = title;

    var hint = (remaining && remaining > 0) ? 'Add ' + money(remaining) + ' more to unlock free shipping' : '';
    var hintEl = head.querySelector('.cc-recs-head__hint');
    if (hintEl.textContent !== hint) hintEl.textContent = hint;

    blocks.forEach(function (block) {
      var p = priceCents(block);
      var unlocks = !!(remaining && remaining > 0 && p !== null && p >= remaining);
      if (block.classList.contains('cc-unlocks') !== unlocks) block.classList.toggle('cc-unlocks', unlocks);
    });
  }

  function refresh() {
    scheduled = false;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var remaining = updateShippingBar(drawer);
    updateRecs(drawer, remaining);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(refresh, 30); // setTimeout (not rAF) so it also runs in background tabs
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(schedule).observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['total-price', 'threshold', 'open']
    });
    ['cart:change', 'cart:refresh', 'variant:add'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(schedule, 50); setTimeout(schedule, 1400); });
    });
    window.addEventListener('resize', schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
